import { snakeStore, SORT_COLUMN, SORT_DIRECTION } from '@/plugins/vuex-async-pagginate';
import { ContactService } from '@pbx/services/ContactService';

export const table = snakeStore(
  {
    state: {
      [SORT_DIRECTION]: 'desc',
      [SORT_COLUMN]: 'last_name'
    },
    actions: {
      getData: (_, params) => ContactService.getTableList(params)
    }
  },
  true
);
